import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4, 5),
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(6, 5),
      minHeight: theme.spacing(35),
    },
  },
  nif: {
    color: theme.palette.grey[200],
  },
  company: {
    margin: theme.spacing(1, 0, 2, 0),
    [theme.breakpoints.up('md')]: {
      margin: theme.spacing(2, 0, 7, 0),
    },
  },
}))

export default useStyles
